import React, { Component } from "react";
import PageHeader from "./components/PageHeader";

class ContactUs extends Component {
  render() {
    return (
      <div style={{ padding: 50 }}>
        <PageHeader
          image={require("./resources/hello2.png")}
          title={"CONTACT US"}
          subTitle={"HOW CAN WE HELP YOU TODAY?"}
        />
        <form
          class="ui form"
          action="https://formspree.io/support@glutenfreelabs.com"
          method="POST"
          style={{ paddingTop: 40 }}
        >
          <div class="field">
            <label style={{ color: "#eb4b2e" }}>Your Name</label>
            <input type="text" name="first-name" placeholder="Full Name" />
          </div>
          <div class="field">
            <label style={{ color: "#eb4b2e" }}>Your Email</label>
            <input type="text" name="email" placeholder="Your Email" />
          </div>
          <div class="field">
            <label style={{ color: "#eb4b2e" }}>Message</label>
            <textarea name="message" />
          </div>
          <button type="submit" value="Send" class="ui button" type="submit">
            Submit
          </button>
        </form>
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/ContactUs.js